/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Ephemeral draft text for lecturer preview formative feedback.
 */
export interface LecturerPreviewFormativeFeedbackRequest {
  /**
   * @minLength 1
   * @maxLength 200000
   */
  draftHtml: string;
}
